<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NCmBSX/tc-custom/9781550925555.jpg?1718282806756" alt="This image is the cover for the book Market Gardener"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Market Gardener
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Few books have grabbed my attention as dramatically as this one—because it’s ultimately do-able for thousands of would-be food and farm healers.” —Joel Salatin, Polyface Farm</b><br/>  <br/><b>Grow <i>better </i>not <i>bigger </i>with proven low-tech, human-scale, biointensive farming methods</b><br/>  <br/> Making a living wage farming without big capital outlay or acreages may be closer than you think. Growing on just 1.5 acres, Jean-Martin and Maude-Helene feed more than 200 families through their thriving CSA and seasonal market stands. The secret of their success is the low-tech, high-yield production methods they’ve developed by focusing on growing better rather than growing bigger, making their operation more lucrative and viable in the process.<br/>  <br/><i>The Market Gardener</i> is a compendium of proven horticultural techniques and innovative growing methods. This complete guide is packed with practical information on:<br/>  <br/> ·       Setting-up a micro-farm by designing biologically intensive cropping systems, all with negligible capital outlay<br/> ·       Farming without a tractor and minimizing fossil fuel inputs through the use of the best hand tools, appropriate machinery and minimum tillage practices<br/> ·       Growing mixed vegetables systematically with attention to weed and pest management, crop yields, harvest periods and pricing approaches.<br/>  <br/> Inspired by the French intensive tradition of maraichage and by iconic American vegetable grower Eliot Coleman, author and farmer Jean-Martin shows by example how to start a market garden and make it both very productive and profitable.<br/>  <br/> “Very well done and should be of great use to market growers everywhere.” —Eliot Coleman, organic farming pioneer and author of <i>The New Organic Grower</i><br/>  <br/> “Both visionary and practical, it is a work of rare intelligence.” —Charles Herve-Gruyer, permaculture teacher and grower at la Fermedu BecHellouin, France</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean-Martin Fortier, Severine von Tscharner Fleming, Marie Bilodeau
      </h2>
      
      <p class="authorDescription body article">Jean-Martin Fortier and his wife Maude-Helene Desroches are the founders of Les Jardins de la Grelinette, an internationally recognized micro-farm famous for its high productivity-profitability using low-tech, high-yield methods of production. He lives in Quebec, Canada.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Society Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b2e59f0